export default "__VITE_ASSET__Zpt8loyO__"